import React from 'react';
import NoteComp from './Note';
function NoteDisplay({ note, isBuilding }) {
    switch (note.type) {
        case 'BuildingNote':
            return React.createElement(NoteComp, { note: note, isBuilding: isBuilding });
        default:
            return null;
    }
}
export default NoteDisplay;
